import React, { useMemo } from 'react';
import Grid from '@mui/material/Grid';
import MDTypography from 'components/MDTypography';
import { SoftCard } from '../ui/SoftCard';

function fmtDateTR(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('tr-TR');
}

function diffDays(aIso, bIso) {
  const a = aIso ? new Date(aIso) : null;
  const b = bIso ? new Date(bIso) : null;
  if (!a || !b || Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return null;
  const ms = b.getTime() - a.getTime();
  return Math.round(ms / (1000 * 60 * 60 * 24));
}

function guessPeriodLabel(startIso, endIso) {
  const days = diffDays(startIso, endIso);
  if (!Number.isFinite(days)) return '—';

  // yaklaşık eşikler
  if (days >= 360) return 'Yıllık';
  if (days >= 27 && days <= 33) return 'Aylık';
  if (days >= 6 && days <= 8) return 'Haftalık';
  return `${days} gün`;
}

export function SmsTopKpis({ sms }) {
  // sms: buildsmsViewModel -> company dto + settings dto birleşik nesnen
  // ama company dto direct veriyorsan da aşağıdaki fallback’ler çalışır.

  const enabled = Boolean(sms?.moduleEnabled ?? sms?.enabled); // iki isim destek
  const quotaLimit = Number(sms?.quotaLimit ?? 0);
  const usedQuota = Number(sms?.usedQuota ?? sms?.quotaUsed ?? 0);
  const remaining = Number.isFinite(sms?.remainingQuota)
    ? Number(sms.remainingQuota)
    : Number.isFinite(sms?.remaining)
    ? Number(sms.remaining)
    : Math.max(0, quotaLimit - usedQuota);
  const used = quotaLimit - remaining;

  const periodStartAt = sms?.periodStartAt ?? sms?.periodStart ?? null;
  const periodEndAt = sms?.periodEndAt ?? sms?.periodEnd ?? null;

  // otomasyon sayısı: settings dto varsa hesaplarız, yoksa 0
  const activeAutomationCount = useMemo(() => {
    const s = sms?.rawSettings || sms; // eğer sms içine settings gömüyorsan
    let c = 0;
    if (s?.attendanceReminder?.enabled) c += 1;
    if (s?.paidSessionInfo?.enabled) c += 1;
    if (s?.birthday?.enabled) c += 1;
    return c;
  }, [sms]);

  const periodLabel = guessPeriodLabel(periodStartAt, periodEndAt);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <SoftCard>
          <MDTypography variant="button" color="text" sx={{ opacity: 0.7 }}>
            Durum
          </MDTypography>

          <MDTypography variant="h4" fontWeight="bold">
            {enabled ? 'Aktif' : 'Pasif'}
          </MDTypography>

          <MDTypography variant="button" color="text" sx={{ opacity: 0.7 }}>
            Dönem: {periodLabel}
          </MDTypography>

          <MDTypography variant="button" color="text" sx={{ opacity: 0.7 }}>
            {fmtDateTR(periodStartAt)} — {fmtDateTR(periodEndAt)}
          </MDTypography>
        </SoftCard>
      </Grid>

      <Grid item xs={12} md={4}>
        <SoftCard>
          <MDTypography variant="button" color="text" sx={{ opacity: 0.7 }}>
            Kota
          </MDTypography>

          <MDTypography variant="h4" fontWeight="bold">
            {remaining}
          </MDTypography>

          <MDTypography variant="button" color="text" sx={{ opacity: 0.7 }}>
            Kullanılan: {used} / Limit: {quotaLimit}
          </MDTypography>
        </SoftCard>
      </Grid>

      <Grid item xs={12} md={4}>
        <SoftCard>
          <MDTypography variant="button" color="text" sx={{ opacity: 0.7 }}>
            Otomasyonlar
          </MDTypography>

          <MDTypography variant="h4" fontWeight="bold">
            {activeAutomationCount}
          </MDTypography>

          <MDTypography variant="button" color="text" sx={{ opacity: 0.7 }}>
            Aktif otomasyon sayısı
          </MDTypography>
        </SoftCard>
      </Grid>
    </Grid>
  );
}
